import { cloneDeep, get, isArray, set } from 'lodash';
import { ANTRAG_TYP, KOSTEN_ARTEN } from '../../../../../lib/constants/constant';
import { getFieldNamefromDataPath, getIDFromResponseOption } from '../../../../../utils/helper';

// import Schemas
// import FoerderProgrammSchema from '../../../../../lib/paths/foerderprogramm_FULL_Paths.json';
import NachweisPositionSchema from '../../../../../lib/paths/nachweisposition_FULL_Paths.json';
import VerwendungsNachweisSchema from '../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsNachweisSchema.attributes;
// const FP_P = FoerderProgrammSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

export const executeVerwendungsnachweisFormulas = (application: any, allFoerderProgramm: any) => {
	let appCopy = cloneDeep(application);
	let result: any[] = [];

	const calculatedPersonalKosten = calculatePersonalkosten(appCopy, allFoerderProgramm);
	if (isArray(calculatedPersonalKosten)) {
		for (let ele of calculatedPersonalKosten) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calculatedPersonalKosten);

	const calculatedSachKosten = calculateSachkosten(appCopy);
	if (isArray(calculatedSachKosten)) {
		for (let ele of calculatedSachKosten) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calculatedSachKosten);

	const calculatedBeantragteFoerderSumme = calculateBeantragteFoerderSumme(appCopy);
	if (isArray(calculatedBeantragteFoerderSumme)) {
		for (let ele of calculatedBeantragteFoerderSumme) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}
	result.push(...calculatedBeantragteFoerderSumme);

	return result;
};

function calculatePersonalkosten(application: any, allFoerderProgramm: any) {
	let result: any[] = [];
	const allkostenPostion = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);
	result.push({
		path: `${VN_P.Verwendungsnachweis_Nachweispositions.path}`,
		value: transformPersonalKosten(application, allkostenPostion, allFoerderProgramm),
	});
	return result;
}
function calculateSachkosten(application: any) {
	let result: any[] = [];
	const allkostenPostion = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);
	result.push({
		path: `${VN_P.Verwendungsnachweis_Nachweispositions.path}`,
		value: transformSachKosten(allkostenPostion),
	});
	return result;
}
function calculateBeantragteFoerderSumme(application: any) {
	let result: any[] = [];
	const allKostenPositions = get(application, VN_P.Verwendungsnachweis_Nachweispositions.path, []);

	const summe = allKostenPositions.reduce(
		(acc: any, ele: any) => acc + parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Foerderung.path, '0')),
		0
	);

	result.push({
		path: VN_P.Allgemein_Tatsaechliche_Summe.path,
		value: !isNaN(summe) ? summe : 0,
	});
	return result;
}

/**
 * *************************************************************************************************************************************************************
 * ************************************************************** HELPER FUNCTIONS *****************************************************************************
 * *************************************************************************************************************************************************************
 */
function transformPersonalKosten(application: any, allKostenPosition: any[], _allFoerderProgramm: any) {
	const programmMap = new Map<string, any>();

	for (const item of allKostenPosition) {
		if (get(item, NP_P.Allgemein_Kostenart.path) === KOSTEN_ARTEN.Personalkosten && get(item, NP_P.Allgemein_Gruppierung_ID.path)) {
			const gruppierungID = get(item, NP_P.Allgemein_Gruppierung_ID.path);
			const foerderprogramm = get(item, NP_P.Foerderprogramm.path);

			if (!programmMap.has(gruppierungID) && foerderprogramm) {
				programmMap.set(gruppierungID, foerderprogramm);
			}
		}
	}

	const allPostionToReturn = allKostenPosition.map((ele: any) => {
		if (get(ele, NP_P.Allgemein_Gruppierung_ID.path) && get(ele, NP_P.Allgemein_Kostenart.path) === KOSTEN_ARTEN.Personalkosten) {
			const gruppierungID = get(ele, NP_P.Allgemein_Gruppierung_ID.path);
			const ersterProgramm = programmMap.get(gruppierungID);
			// const stundeProWoche = parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Ustd_Woche.path, '0')) || 0;
			// const uwo = parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Uwo.path, '0')) || 0;
			// const honorarSatz =
			// 	parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Honorarsatz.path, '0')) ;
			// const beantragteFoerderung = stundeProWoche * uwo * honorarSatz;
			const stundeProWoche = parseFloat(get(ele, NP_P.Bewilligte_Foerderung_Ustd_Woche.path, '0')) || 0;
			const uwo = parseFloat(get(ele, NP_P.Bewilligte_Foerderung_Uwo.path, '0')) || 0;
			const Bewilligte_UStd = stundeProWoche * uwo;
			const honorarSatz = parseFloat(get(ele, NP_P.Bewilligte_Foerderung_Honorarsatz.path, '0')) || 0;
			const tatsaechliche_UStd = parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Tatsaechliche_U_Std.path, '0')) || 0;
			const tatsaechliche_sachkosten = parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Sachkosten.path, '0')) || 0;
			// const Minderstunden = tatsaechliche_UStd - Bewilligte_UStd;
			const tatsaechliche_personalkosten = tatsaechliche_UStd * honorarSatz;
			const tatsaechlicheFoerderung = tatsaechliche_personalkosten + tatsaechliche_sachkosten;


			const returData = {
				...ele,
				attributes: {
					...get(ele, 'attributes', {}),
					[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Honorarsatz.path)]: !isNaN(honorarSatz) ? honorarSatz : 0,
					[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Bewilligte_U_Std.path)]: !isNaN(Bewilligte_UStd) ? Bewilligte_UStd : 0,
					[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Sachkosten.path)]: !isNaN(tatsaechliche_sachkosten) ? tatsaechliche_sachkosten : 0,
					[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Personalkosten.path)]: !isNaN(tatsaechliche_personalkosten) ? tatsaechliche_personalkosten : 0,
					[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Anerkannte_U_Std.path)]: !isNaN(tatsaechliche_UStd) ? tatsaechliche_UStd : 0,
					[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Anerkannte_Sachkosten.path)]: !isNaN(tatsaechliche_sachkosten) ? tatsaechliche_sachkosten : 0,
					[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Foerderung.path)]:
						!isNaN(tatsaechlicheFoerderung) ? tatsaechlicheFoerderung : 0,
					[getFieldNamefromDataPath(NP_P.Foerderprogramm.path)]: getIDFromResponseOption(ersterProgramm), // Förderprogramm ersetzen
				},
			};
			if (get(application, VN_P.Allgemein_Nachweistyp.path, '').trim() === ANTRAG_TYP.Zwischenmeldung) {
				const Bewilligte_U_Std = parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Bewilligte_U_Std.path, '0')) || 0;
				const Tatsaechliche_U_Std = parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Tatsaechliche_U_Std.path, '0')) || 0;
				const Prognostizierte_U_Std = parseFloat(get(ele, NP_P.Tatsaechliche_Foerderung_Prognostizierte_U_Std.path, '0')) || 0;
				const unt_Woche = parseFloat(get(ele, NP_P.Bewilligte_Foerderung_Ustd_Woche.path, '0')) || 0;
				const UWo = parseFloat(get(ele, NP_P.Bewilligte_Foerderung_Uwo.path, '0')) || 0;

				const Minderstunden = (Prognostizierte_U_Std + Tatsaechliche_U_Std) - Bewilligte_U_Std;
				const Bewilligte_UStd = unt_Woche * UWo;
				const tatsaechliche_personalkosten = (tatsaechliche_UStd + Prognostizierte_U_Std) * honorarSatz;
				const tatsaechlicheFoerderung = tatsaechliche_personalkosten + tatsaechliche_sachkosten;

				const returData = {
					...ele,
					attributes: {
						...get(ele, 'attributes', {}),
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Honorarsatz.path)]: !isNaN(honorarSatz) ? honorarSatz : 0,
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Personalkosten.path)]: !isNaN(tatsaechliche_personalkosten) ? tatsaechliche_personalkosten : 0,
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Minderstunden.path)]:
							!isNaN(Minderstunden) ? Minderstunden : 0,
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Bewilligte_U_Std.path)]:
							!isNaN(Bewilligte_UStd) ? Bewilligte_UStd : 0,
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Anerkannte_U_Std.path)]:
							!isNaN(Tatsaechliche_U_Std) ? Tatsaechliche_U_Std : 0,
						[getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_Tatsaechliche_Foerderung.path)]:
							!isNaN(tatsaechlicheFoerderung) ? tatsaechlicheFoerderung : 0,
						[getFieldNamefromDataPath(NP_P.Foerderprogramm.path)]: getIDFromResponseOption(ersterProgramm),
					},
				};

				return returData;
			}
			return returData;

		} else {
			return ele;
		}
	});
	return allPostionToReturn;
}
function transformSachKosten(allKostenPosition: any[]) {
	const programmMap = new Map<string, any>();

	for (const item of allKostenPosition) {
		if (get(item, NP_P.Allgemein_Kostenart.path) === KOSTEN_ARTEN.Sachkosten && get(item, NP_P.Allgemein_Gruppierung_ID.path)) {
			const gruppierungID = get(item, NP_P.Allgemein_Gruppierung_ID.path);
			const foerderprogramm = get(item, NP_P.Foerderprogramm.path);

			if (!programmMap.has(gruppierungID) && foerderprogramm) {
				programmMap.set(gruppierungID, foerderprogramm);
			}
		}
	}

	return allKostenPosition.map((ele: any) => {
		if (get(ele, NP_P.Allgemein_Gruppierung_ID.path) && get(ele, NP_P.Allgemein_Kostenart.path) === KOSTEN_ARTEN.Sachkosten) {
			const gruppierungID = get(ele, NP_P.Allgemein_Gruppierung_ID.path);
			const ersterProgramm = programmMap.get(gruppierungID);

			if (ersterProgramm) {
				return {
					...ele,
					attributes: {
						...get(ele, 'attributes', {}),
						// [getFieldNamefromDataPath(NP_P.Tatsaechliche_Foerderung_beantragte_Foerderung.path)]: beantragteFoerderung,
						[getFieldNamefromDataPath(NP_P.Foerderprogramm.path)]: getIDFromResponseOption(ersterProgramm), // Förderprogramm ersetzen
					},
				};
			}
		}
		return ele;
	});
}
// function getHonorarSatzAusFoerderProgramm(programmId: number, allFoerderProgramm: any): number {
// 	const selectedProgramm = allFoerderProgramm.find((ele: any) => get(ele, 'id') === programmId);

// 	return parseFloat(get(selectedProgramm, FP_P.Vorgaben_Honorarsatz.path, '0'));
// }
